import { createReducer } from '@reduxjs/toolkit';

import uploadFile, { clearUploadFile } from '../../thunks/general/uploadFile';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const uploadFileReducer = createReducer(initialState, {
  [uploadFile.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [uploadFile.fulfilled]: (state, { payload: data }) => ({
    ...state,
    data,
    loading: false,
  }),
  [uploadFile.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearUploadFile]: () => initialState,
});

export default uploadFileReducer;
